import { useState, type MouseEvent } from 'react';
import { GridActionsCellItem } from '@mui/x-data-grid-premium';
import { Popover } from '@airbus/components-react';
import { Close } from '@airbus/icons/react';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { ClickAwayListener } from '@mui/material';
import styles from './RowErrorAction.module.css';
import { useLanguageContextAPI } from '../../context/LanguageContext';

export function DeletionRequestAction() {
  const [btnNode, setBtnNode] = useState<HTMLElement | null>(null);
  const [open, setOpen] = useState(false);
  const { t } = useLanguageContextAPI();

  const handleClickPopover = (event: MouseEvent<HTMLElement>) => {
    setBtnNode(event.currentTarget);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  return (
    <>
      <GridActionsCellItem
        icon={<DeleteOutlineIcon sx={{ fontSize: 18, color: '#1B1B1B' }} />}
        label='Deletion details'
        onClick={handleClickPopover}
        showInMenu={false}
      />
      <Popover
        referenceNode={btnNode}
        open={open}
        placement='bottom-start'
        arrowClassName='custom-popover-arrow'
        className={styles.poopover}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <div className={styles.popoverContainer}>
            <div className={styles.header}>
              <div className={styles.headerText}>{t('deletion_request.popover_title')}</div>
              <button onClick={handleClose} className={styles.closeButtonDiv} aria-label='Close'>
                <Close className={styles.closeButton} />
              </button>
            </div>

            <div className={styles.errorList}>
              <div className={styles.errorItem}>
                <div className={styles.errorText} style={{ color: '#1B1B1B', cursor: 'default' }}>
                  {t('deletion_request.popover_detail')}
                </div>
              </div>
            </div>
          </div>
        </ClickAwayListener>
      </Popover>
    </>
  );
}
